var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "comment__item" }, [
    _c("div", { staticClass: "comment__item-header" }, [
      _vm.comment.name
        ? _c("label", { staticClass: "comment__item-name" }, [
            _vm._v(_vm._s(_vm.comment.name)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("span", { staticClass: "comment__item-date" }, [
        _vm._v("\n      " + _vm._s(_vm.persianDateTime()) + "\n    "),
      ]),
      _vm._v(" "),
      _vm.comment.isWaitingToConfirm
        ? _c("span", [_vm._v("\n      در انتظار تأیید\n    ")])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "comment__item-content" }, [
      _c("div", { staticClass: "comment__item-detail" }, [
        _c("p", { domProps: { innerHTML: _vm._s(_vm.comment.message) } }),
      ]),
      _vm._v(" "),
      !_vm.comment.isWaitingToConfirm
        ? _c(
            "div",
            { staticClass: "comment__item-footer" },
            [
              _c("button", { on: { click: _vm.openReplyForm } }, [
                _c("i", { staticClass: "icon-arrow-left" }),
                _vm._v("\n          پاسخ دادن\n        "),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "comment__item-reply",
                  class: { "is-show": _vm.isReplying },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "comment__form-textarea comment__form-textarea--reply",
                    },
                    [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.replyMessage,
                            expression: "replyMessage",
                          },
                        ],
                        ref: "replyMessage",
                        attrs: {
                          maxlength: _vm.commentViewDataModel.commentLength,
                          disabled: _vm.isVoting,
                          placeholder:
                            "دیدگاه خود درباره این مطلب را اینجا بنویسید",
                          autocomplete: "off",
                        },
                        domProps: { value: _vm.replyMessage },
                        on: {
                          keyup: _vm.checkMessageIsValid,
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.replyMessage = $event.target.value
                          },
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.replyMessageError.length
                    ? _c("span", { staticClass: "form-validation" }, [
                        _vm._v(_vm._s(_vm.replyMessageError)),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "comment__form-submit" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn--primary p--0",
                        attrs: { disabled: !_vm.replyMessage.length },
                        on: { click: _vm.replyComment },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.sendButtonText) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "transition-group",
                { attrs: { name: "fade" } },
                _vm._l(_vm.comment.comments, function (comment) {
                  return _c("Comment", {
                    key: comment.id,
                    attrs: { comment: comment },
                  })
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }